import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ArbolCategoria`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las categorías.',
      tipoError: 'arbolCategoria'
    }
  })
}

export function buscarSubcategoria(idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarSubcategoria/${idCategoria}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las subcategorías.',
      tipoError: 'arbolCategoria'
    }
  })
}
